import { render, staticRenderFns } from "./CalibrationC1.vue?vue&type=template&id=2e01c27c&scoped=true"
import script from "./CalibrationC1.vue?vue&type=script&lang=js"
export * from "./CalibrationC1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e01c27c",
  null
  
)

export default component.exports